import ModalNew from "../../ui/popup/Modal";
import { PopupHeader, PopupContent } from "../../ui/popup/common";
import FilingSummaryContent from "../../ui/filings/FilingSummaryContent";

function FilingDetailsModal({ filing, onClose }) {
  return (
    <ModalNew style={{ maxWidth: "600px" }}>
      <PopupHeader 
        title="Filing Summary" 
        setOpenState={onClose}
        icon={`${process.env.PUBLIC_URL}/images/icons/filing_blue.svg`}
        variant="compact"
      />
      <PopupContent>
        <FilingSummaryContent 
          filing={filing} 
          showPrice={true}
          priceLabel="Total Filing Price"
        />
      </PopupContent>
    </ModalNew>
  );
}

export default FilingDetailsModal;
